/* ==========================================================================
   TRX x Kenetik Performance Shot -- landing page behaviour
   Owner: Katie Spaller.  Spec: docs/trx-kenetik-shot-lp-build-spec.md v2.2
   Forked from ks-raspberry-lychee-lp.js.

   EVERYTHING IS SCOPED TO THE SECTION ELEMENT. No getElementById, no
   first-match document.querySelector. Those break every other subscription
   section in this theme if this page is ever duplicated, and they silently
   bind the wrong form when two instances exist.

   The buy box degrades to a real <form action="/cart/add"> with hidden id +
   quantity and a name="selling_plan" select. This file only upgrades the
   experience; with JS off the page still sells.

   No new dependencies. jQuery is already global via layout/cw-layout.liquid
   L306, but nothing here uses it -- the cart drawer handoff is the only
   touchpoint and that is a plain global function call.
   ========================================================================== */
(function () {
  'use strict';

  function money(cents, format) {
    var v = (cents / 100).toFixed(2);
    if (format && format.indexOf('amount_no_decimals') > -1) {
      v = Math.round(cents / 100).toString();
    }
    return '$' + v;
  }

  function initShop(root) {
    var form     = root.querySelector('[data-trx-form]');
    if (!form) return;

    var variantInput = root.querySelector('[data-trx-variant-input]');
    var qtyInput     = root.querySelector('[data-trx-qty-input]');
    var qtyOut       = root.querySelector('[data-trx-qty-val]');
    var totalEl      = root.querySelector('[data-trx-total]');
    var shipNote     = root.querySelector('[data-trx-ship]');
    var subCard      = root.querySelector('[data-trx-mode="sub"]');
    var planSelect   = root.querySelector('[data-trx-plan]');
    var termsEl      = root.querySelector('[data-trx-terms]');
    var excludeNote  = root.querySelector('[data-trx-exclude-note]');
    var submitBtn    = root.querySelector('[name="add"]');
    var stickyPack   = root.querySelector('[data-trx-sticky-pack]');
    var stickyPrice  = root.querySelector('[data-trx-sticky-price]');
    var mainImg      = root.querySelector('[data-trx-main-img]');

    var fmt       = root.getAttribute('data-money-format') || '';
    var threshold = parseInt(root.getAttribute('data-ship-threshold'), 10);
    var shipOver  = root.getAttribute('data-ship-over-text')  || '';
    var shipUnder = root.getAttribute('data-ship-under-text') || '';

    var packs = Array.prototype.slice.call(root.querySelectorAll('[data-trx-pack]'));
    var modes = Array.prototype.slice.call(root.querySelectorAll('[data-trx-mode]'));

    var state = {
      variantId: variantInput ? variantInput.value : null,
      mode: 'once',
      qty: 1
    };

    function currentPack() {
      for (var i = 0; i < packs.length; i++) {
        if (packs[i].getAttribute('data-variant-id') === String(state.variantId)) return packs[i];
      }
      return null;
    }

    function render() {
      var pack = currentPack();
      if (!pack) return;

      var oncePrice = parseInt(pack.getAttribute('data-price'), 10);
      var subPrice  = pack.getAttribute('data-sub-price');
      subPrice = subPrice === '' || subPrice === null ? null : parseInt(subPrice, 10);
      var hasPlans  = pack.getAttribute('data-has-plans') === 'true';

      /* AVAILABILITY-DRIVEN, never hardcoded. When a variant carries no
         selling_plan_allocations the subscribe card is REMOVED from the DOM,
         not disabled. This is what lets the page ship against a draft,
         $0.00, zero-plan product and light up on its own the moment Recharge
         attaches -- no redeploy. Contrast KS-partner-subscription.liquid,
         which leaves a Subscribe button that silently adds a one-time item. */
      if (subCard) {
        subCard.hidden = !hasPlans;
        if (!hasPlans && state.mode === 'sub') state.mode = 'once';
      }
      if (excludeNote) {
        excludeNote.hidden = !(pack.getAttribute('data-excluded') === 'true');
      }

      packs.forEach(function (p) {
        p.setAttribute('aria-checked', String(p.getAttribute('data-variant-id') === String(state.variantId)));
      });
      modes.forEach(function (m) {
        m.setAttribute('aria-checked', String(m.getAttribute('data-trx-mode') === state.mode));
      });

      var onceEl = root.querySelector('[data-trx-once-price]');
      if (onceEl) onceEl.textContent = money(oncePrice, fmt);
      if (subPrice !== null) {
        var sp = root.querySelector('[data-trx-sub-price]');
        var sw = root.querySelector('[data-trx-sub-was]');
        if (sp) sp.textContent = money(subPrice, fmt);
        if (sw) sw.textContent = money(oncePrice, fmt);
      }

      var each  = (state.mode === 'sub' && subPrice !== null) ? subPrice : oncePrice;
      var total = each * state.qty;

      if (totalEl) totalEl.textContent = money(total, fmt);
      if (qtyOut)  qtyOut.textContent  = state.qty;
      if (qtyInput) qtyInput.value     = state.qty;
      if (variantInput) variantInput.value = state.variantId;

      if (termsEl) termsEl.hidden = (state.mode !== 'sub');

      /* The selling_plan select must only submit when subscribe is chosen.
         Disabled inputs are not serialised, which is exactly what we want --
         it keeps the no-JS form honest too. */
      if (planSelect) planSelect.disabled = (state.mode !== 'sub');

      /* Shipping note renders ONLY when true for the ACTUAL selected price,
         subscription discount included. At the 6/12/24 lineup the only
         qualifying case is the 24-pack bought one-time; the same pack on
         subscription is $95.81 and falls back under the $100 threshold. */
      if (shipNote && !isNaN(threshold)) {
        var t = threshold * 100;
        if (total >= t) {
          shipNote.hidden = shipOver === '';
          shipNote.textContent = shipOver;
        } else if (shipUnder !== '' && shipUnder.indexOf('[amount]') > -1) {
          shipNote.hidden = false;
          shipNote.textContent = shipUnder.replace('[amount]', money(t - total, fmt));
        } else {
          shipNote.hidden = true;
        }
      }

      /* Pack-specific pack shot. A variant only gets one if an image is
         actually assigned to it in Shopify; when it has none we fall back to
         the section's default rather than blanking the frame, so an
         un-imaged variant degrades to the product shot instead of a hole. */
      if (mainImg) {
        var vimg = pack.getAttribute('data-variant-img');
        var target = vimg || mainImg.getAttribute('data-default-src');
        if (target && mainImg.getAttribute('src') !== target) {
          mainImg.removeAttribute('srcset');
          mainImg.setAttribute('src', target);
          var valt = pack.getAttribute('data-variant-img-alt');
          if (vimg && valt) mainImg.setAttribute('alt', valt);
        }
        if (vimg) {
          root.querySelectorAll('[data-trx-thumb]').forEach(function (t) {
            t.setAttribute('aria-current', 'false');
          });
        }
      }

      if (stickyPack)  stickyPack.textContent  = pack.getAttribute('data-pack-title') || '';
      if (stickyPrice) stickyPrice.textContent = money(total, fmt);

      var soldOut = pack.getAttribute('data-available') === 'false';
      if (submitBtn) {
        submitBtn.disabled = soldOut;
        var lbl = submitBtn.getAttribute(soldOut ? 'data-text-soldout' : 'data-text-default');
        if (lbl) submitBtn.textContent = lbl;
      }
    }

    packs.forEach(function (p) {
      p.addEventListener('click', function () {
        if (p.hasAttribute('disabled')) return;
        state.variantId = p.getAttribute('data-variant-id');
        render();
      });
    });

    modes.forEach(function (m) {
      m.addEventListener('click', function () {
        state.mode = m.getAttribute('data-trx-mode');
        render();
      });
    });

    root.querySelectorAll('[data-trx-qty]').forEach(function (b) {
      b.addEventListener('click', function () {
        var max = parseInt(root.getAttribute('data-qty-max'), 10) || 10;
        var d = parseInt(b.getAttribute('data-trx-qty'), 10);
        state.qty = Math.min(max, Math.max(1, state.qty + d));
        render();
      });
    });

    /* Gallery thumbs. Clicking a thumb overrides the pack shot until the pack
       changes again -- deliberate: someone inspecting the label does not want
       it swapped out from under them by an unrelated re-render. */
    root.querySelectorAll('[data-trx-thumb]').forEach(function (t) {
      t.addEventListener('click', function () {
        root.querySelectorAll('[data-trx-thumb]').forEach(function (x) {
          x.setAttribute('aria-current', 'false');
        });
        t.setAttribute('aria-current', 'true');
        var src = t.getAttribute('data-full');
        if (mainImg && src) {
          mainImg.setAttribute('src', src);
          mainImg.removeAttribute('srcset');
          var alt = t.getAttribute('data-alt');
          if (alt !== null) mainImg.setAttribute('alt', alt);
        }
      });
    });

    /* ATC -> cart drawer.
       The live drawer is cw-side-cart, rendered inside sections/cw-header.liquid
       and opened by the global openCartDrawer() defined in
       assets/cw-custom-dev.js.liquid. It is a FUNCTION CALL, not an event.
       Every other ATC in this theme uses the same typeof guard. Falls back to
       a /cart redirect so a drawer failure can never swallow an add. */
    form.addEventListener('submit', function (e) {
      if (!window.fetch) return;           /* let the native form post */
      e.preventDefault();
      if (submitBtn) submitBtn.disabled = true;

      var body = new FormData(form);
      fetch('/cart/add.js', {
        method: 'POST',
        body: body,
        credentials: 'same-origin',
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      })
        .then(function (r) {
          if (!r.ok) throw new Error('cart/add failed: ' + r.status);
          return r.json();
        })
        .then(function () {
          if (submitBtn) submitBtn.disabled = false;
          if (typeof window.openCartDrawer === 'function') {
            window.openCartDrawer();
          } else {
            window.location.href = '/cart';
          }
        })
        .catch(function () {
          /* Never leave the customer stuck on a dead button. */
          window.location.href = '/cart';
        });
    });

    /* Sticky bar: reveal once the buy box has scrolled past, hide again while
       the buy box is in view so it never covers the real ATC. */
    var sticky = root.querySelector('[data-trx-sticky]');
    var anchor = root.querySelector('[data-trx-anchor]');
    if (sticky && anchor && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          var past = en.boundingClientRect.top < 0 && !en.isIntersecting;
          sticky.classList.toggle('is-on', past);
        });
      }, { threshold: 0 }).observe(root);
    }

    render();
  }

  /* Video facade. The iframe is injected only on click -- a YouTube embed is
     roughly 900KB and would destroy the INP budget if loaded eagerly. */
  function initVideo(root) {
    var btn = root.querySelector('[data-trx-video-btn]');
    if (!btn) return;
    btn.addEventListener('click', function () {
      var src = root.getAttribute('data-video-src');
      var wrap = root.querySelector('[data-trx-video-wrap]');
      if (!src || !wrap) return;
      var iframe = document.createElement('iframe');
      iframe.setAttribute('src', src + (src.indexOf('?') > -1 ? '&' : '?') + 'autoplay=1');
      iframe.setAttribute('title', root.getAttribute('data-video-title') || 'Video');
      iframe.setAttribute('allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture');
      iframe.setAttribute('allowfullscreen', '');
      iframe.setAttribute('loading', 'lazy');
      wrap.innerHTML = '';
      wrap.appendChild(iframe);
    });
  }

  /* ---- Cross-sell buy cards ---------------------------------------------
     Forked from initCrossCard in ks-raspberry-lychee-lp.js, which itself
     replaced the jQuery handlers in cw-custom-dev.js that key off
     .js_parent--box and collide as soon as two grids are on one page.

     SCOPED TWICE OVER. initCrosssell takes the SECTION element and hands each
     card element to initCrosssellCard, which never looks outside that card.
     Two cross-sell sections, or two cards for the same product, cannot bind
     each other's form -- and none of this can touch the buy box in
     ks-trx-shop, which is a different section element with a different form.

     Hidden variants are absent from the JSON table the section emits, so they
     cannot be resolved, priced or posted from here. Do not "improve" this by
     reading window.ShopifyAnalytics or a /products/x.js fetch -- both would
     hand back the suppressed variants. */
  function initCrosssellCard(card, fmt) {
    var form = card.querySelector('[data-trx-cross-form]');
    if (!form) return;

    var dataEl  = card.querySelector('[data-trx-cross-variants]');
    var idInput = card.querySelector('[data-trx-cross-variant]');
    var priceEl = card.querySelector('[data-trx-cross-price]');
    var addBtn  = card.querySelector('[data-trx-cross-add]');
    var addLbl  = card.querySelector('[data-trx-cross-add-label]');
    var errEl   = card.querySelector('[data-trx-cross-error]');
    var selects = Array.prototype.slice.call(card.querySelectorAll('[data-trx-cross-option]'));

    /* Labels come from the schema, not from string literals in here, so they
       stay translatable and editable. */
    var txtDefault = addBtn && addBtn.getAttribute('data-text-default');
    var txtSoldout = addBtn && addBtn.getAttribute('data-text-soldout');
    var txtUnavail = addBtn && addBtn.getAttribute('data-text-unavailable');
    if (!txtDefault) txtDefault = addLbl ? addLbl.textContent.trim() : 'Add to cart';
    if (!txtSoldout) txtSoldout = 'Sold out';
    if (!txtUnavail) txtUnavail = 'Unavailable';

    var variants = [];
    if (dataEl) {
      try { variants = JSON.parse(dataEl.textContent) || []; } catch (e) { variants = []; }
    }

    function resolve() {
      var picked = selects.map(function (sel) { return sel.value; });
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        var vals = [v.o1, v.o2, v.o3];
        var match = true;
        for (var j = 0; j < picked.length; j++) {
          if (String(vals[j] || '') !== String(picked[j] || '')) { match = false; break; }
        }
        if (match) return v;
      }
      return null;
    }

    function current() {
      return selects.length ? resolve() : variants[0];
    }

    function render() {
      var v = current();

      /* No variant for this combination: the flavour is not made in that pack
         size. Say so on the button rather than posting a wrong id. */
      if (!v) {
        if (addBtn) addBtn.setAttribute('aria-disabled', 'true');
        if (addLbl) addLbl.textContent = txtUnavail;
        return;
      }
      if (idInput) idInput.value = v.id;
      if (priceEl) priceEl.textContent = money(v.price, fmt);
      if (addBtn) {
        if (v.available) { addBtn.removeAttribute('aria-disabled'); }
        else { addBtn.setAttribute('aria-disabled', 'true'); }
      }
      if (addLbl) addLbl.textContent = v.available ? txtDefault : txtSoldout;
    }

    selects.forEach(function (sel) { sel.addEventListener('change', render); });

    form.addEventListener('submit', function (e) {
      if (!window.fetch) return;           /* let the native form post */
      e.preventDefault();

      if (errEl) { errEl.hidden = true; errEl.textContent = ''; }
      var v = current();
      if (!v || !v.available) return;
      if (addBtn) addBtn.setAttribute('aria-busy', 'true');

      fetch('/cart/add.js', {
        method: 'POST',
        body: new FormData(form),
        credentials: 'same-origin',
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      })
        .then(function (r) {
          return r.json().then(function (d) {
            if (!r.ok) throw new Error(d.description || d.message || 'cart/add failed: ' + r.status);
            return d;
          });
        })
        .then(function () {
          /* Same handoff as the buy box: the live drawer is cw-side-cart,
             opened by the global openCartDrawer() in cw-custom-dev.js.liquid.
             A FUNCTION CALL, not an event, behind a typeof guard, with a
             /cart redirect so a drawer failure can never swallow an add. */
          if (typeof window.openCartDrawer === 'function') {
            window.openCartDrawer();
          } else {
            window.location.href = '/cart';
          }
        })
        .catch(function (err) {
          /* Unlike the buy box this reports in place instead of redirecting.
             A cross-sell add is not the page's primary conversion, so throwing
             the customer at /cart would abandon the buy box they were using. */
          if (errEl) {
            errEl.textContent = (err && err.message) ? err.message : 'Could not add to cart.';
            errEl.hidden = false;
          }
        })
        .then(function () {
          if (addBtn) addBtn.removeAttribute('aria-busy');
        });
    });

    render();
  }

  function initCrosssell(root) {
    var fmt = root.getAttribute('data-money-format') || '';
    root.querySelectorAll('[data-trx-cross-card]').forEach(function (card) {
      initCrosssellCard(card, fmt);
    });
  }

  function boot(scope) {
    (scope || document).querySelectorAll('[data-ks-trx-shop]').forEach(initShop);
    (scope || document).querySelectorAll('[data-ks-trx-video]').forEach(initVideo);
    (scope || document).querySelectorAll('[data-ks-trx-crosssell]').forEach(initCrosssell);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(document); });
  } else {
    boot(document);
  }

  /* Shopify theme editor re-renders a section without a page load. */
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
